import React, { useEffect } from 'react';
import { Typography, useTheme } from "@mui/material";
import ReceiverDetailView from "./component/ReceiverDetailView";
import HistoryView from "./HistoryView";
import { ModuleHeader } from "../../components/composed";
import { Card } from "../../components/primitives";
import { FadeIn, SlideUp } from "../../components/motion";

export default function UserView(props) {
  const theme = useTheme();

  useEffect(() => {
    props.setShowSearch(false);
  }, []);

  return (
    <FadeIn>
      <ModuleHeader
        title="My Profile"
        subtitle="View your information and notification history"
        moduleColor={theme.palette.user?.main || '#10B981'}
      />

      <SlideUp delay={0.1}>
        <Card
          sx={{ mt: 3, p: 3 }}
          accent={theme.palette.user?.main || '#10B981'}
        >
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
            User information
          </Typography>
          <ReceiverDetailView receiverId={props.user.id} readOnly={true}
                              {...props}
          />
        </Card>
      </SlideUp>

      <SlideUp delay={0.2}>
        <Card
          sx={{ mt: 3, p: 3 }}
          accent={theme.palette.user?.main || '#10B981'}
        >
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
            Sent notifications
          </Typography>
          <HistoryView userId={props.user.id}
                       {...props}
          />
        </Card>
      </SlideUp>
    </FadeIn>
  );
}
